<script setup>
import { WdsIcon } from '@wds/components';

const { t } = useI18n();
const { $tracking } = useNuxtApp();
const route = useRoute();
const { origin } = useRequestURL();

const reportUrl = computed(() => {
  const url = new URL(t('t_HWHELPREPORT'));
  url.searchParams.set('referrer', new URL(route.path, origin).href);
  return url.href;
});

function handlePropertyReport() {
  $tracking?.onReportPropertyClick();
}
</script>

<template>
  <a
    :href="reportUrl"
    class="report-link link-2-reg"
    rel="noopener noreferrer"
    :aria-label="t('t_REPORT')"
    target="_blank"
    :title="t('t_REPORT')"
    @click="handlePropertyReport"
  >
    <WdsIcon
      asset="flag"
      color="ink"
    />
    <span>{{ t('t_REPORT') }}</span>
  </a>
</template>

<style lang="scss" scoped>
.report-link {
  display: flex;
  align-items: center;
  gap: $wds-spacing-s;
  color: $wds-color-ink;

  &:active {
    color: $wds-color-ink;
  }

  &:focus-visible {
    box-shadow: $border-focus-default;
    color: $wds-color-ink;
  }

  &:hover span {
    text-decoration: underline;
  }
}
</style>
